module.exports = __webpack_public_path__ + "static/media/ascasubi.af1680e7.jpg";